import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const PopularStocksCard = ({ stocks, onPick }) => (
  <Card data-testid="popular-stocks-card">
    <CardHeader>
      <CardTitle>Popular Stocks</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3">
        {stocks.map((stock) => (
          <div
            key={stock.symbol}
            className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors"
            onClick={() => onPick(stock)}
            data-testid={`popular-row-${stock.symbol}`}
          >
            <div>
              <p className="font-semibold text-gray-900">{stock.symbol}</p>
              <p className="text-sm text-gray-600">{stock.name}</p>
            </div>
            <div className="text-right">
              <p className="font-semibold text-gray-900">${stock.price?.toFixed(2)}</p>
              <div className="flex items-center gap-1">
                {stock.change >= 0 ? (
                  <TrendingUp size={16} className="text-green-600" />
                ) : (
                  <TrendingDown size={16} className="text-red-600" />
                )}
                <span className={stock.change >= 0 ? 'text-green-600' : 'text-red-600'}>
                  {stock.changePercent?.toFixed(2)}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);

export default PopularStocksCard;
